import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ApiError } from "@/api/client";
import { fetchExternalServices } from "@/api/externalServices";
import { SelectInput } from "@/components/admin/AdminShell";
import type { ExternalServiceDto } from "@/types/externalService";

export function ExternalServicePicker({
  value,
  currentName,
  disabled,
  onChange,
}: {
  value: number | null;
  currentName?: string | null;
  disabled?: boolean;
  onChange: (serviceId: number | null) => void;
}) {
  const [services, setServices] = useState<ExternalServiceDto[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    void fetchExternalServices()
      .then((items) => {
        if (!cancelled) setServices(items);
      })
      .catch((reason) => {
        if (!cancelled) {
          setError(
            reason instanceof ApiError
              ? reason.message
              : "Не удалось загрузить внешние сервисы",
          );
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const currentMissing =
    value != null && !services.some((service) => service.id === value);

  return (
    <div>
      <SelectInput
        id="form-settings-external-service"
        size="compact"
        value={value == null ? "" : String(value)}
        disabled={disabled || loading}
        onChange={(next) => onChange(next ? Number(next) : null)}
      >
        <option value="">Обычная форма</option>
        {currentMissing ? (
          <option value={value ?? ""}>
            {currentName || `Сервис #${value}`}
          </option>
        ) : null}
        {services.map((service) => (
          <option key={service.id} value={service.id}>
            {service.name}
          </option>
        ))}
      </SelectInput>
      <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 font-onest text-xs">
        {loading ? <span className="text-slate-400">Загрузка…</span> : null}
        {error ? <span className="text-red-600">{error}</span> : null}
        <Link
          to="/admin/external-services"
          className="text-brand-600 hover:text-brand-700 hover:underline"
        >
          Управление сервисами
        </Link>
      </div>
    </div>
  );
}
